import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import * as Linking from 'expo-linking';
import { setDeepLinkAction } from '../store/actions/auth';

export const useSetDeepLink = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const handleUrl = (url) => {
      if (url) {
        dispatch(setDeepLinkAction(url));
      }
    };

    const handleEvent = ({ url }) => {
      handleUrl(url);
    };

    // Add event listener for deep links
    const subscription = Linking.addEventListener('url', handleEvent);

    // Check for the initial URL
    Linking.getInitialURL().then((url) => handleUrl(url));

    return () => {
      subscription.remove();
    };
  }, [dispatch]);
};
